import { Empty } from "antd"

const NoRecordFound = () => {
    return (
        <div className="no-record-parent">
            {/* <Empty  description="No Record Found"/> */}
            <div className="ant-empty-description">
                Sorry we couldn't find that... <br /> Try searching for something else...
            </div>
        </div>

    )
}
export default NoRecordFound